import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { ReferenceBook } from '@/features/organizations/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const gasRouteTypesApi = createApi({
  reducerPath: 'gasRouteTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/gas-route-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getGasRouteTypes: builder.query<ReferenceBook[], void>({
      query: () => ({
        url: `/`,
      }),
    }),
  }),
});

export const { useGetGasRouteTypesQuery } = gasRouteTypesApi;
